import React, { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "./api";

const AdminAuthCtx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = no user, object = logged in
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("admin_token");
      if (!token) { setUser(false); setLoading(false); return; }
      try {
        const { data } = await adminApi.get("/admin/me");
        setUser(data);
      } catch {
        localStorage.removeItem("admin_token");
        setUser(false);
      } finally { setLoading(false); }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await adminApi.post("/admin/login", { email, password });
    localStorage.setItem("admin_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("admin_token");
    setUser(false);
    window.location.href = "/admin/login";
  };

  return (
    <AdminAuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AdminAuthCtx.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthCtx);
